import { render } from "./ProductButton.vue?vue&type=template&id=4d1eb618&scoped=true&ts=true"
import script from "./ProductButton.vue?vue&type=script&lang=ts"
export * from "./ProductButton.vue?vue&type=script&lang=ts"

import "./ProductButton.vue?vue&type=style&index=0&id=4d1eb618&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1eb618"]])

export default __exports__